import React, { useEffect, useState } from "react";
import { useChartContext } from "../../Context/ChartsContext";
import LineRaceChart from "../../CHARTS/LineRaceChart";
import DottedBarChart from "../../CHARTS/DottedBarChart";
import { MdVisibility } from "react-icons/md";
import { getDaysInMonth } from "../../Utilitie";
const Speed = () => {
  const { bestSheetDataObj } = useChartContext();
  const [visibleTable, setVisibleTable] = useState(null);
  const [bestSheetData, setBestSheetData] = useState(null);
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    setVisibleTable(bestSheetDataObj.visibleTable);
    setBestSheetData(bestSheetDataObj.bestSheetData);
  }, [bestSheetDataObj]);
  useEffect(() => {
    if (bestSheetData && visibleTable) {
      let newChartData = [];

      Object.entries(visibleTable).forEach(([key, value]) => {
        if (value) {
          bestSheetData.forEach((fyObj) => {
            if (fyObj.F_YEAR === key) {
              fyObj.months.forEach((monthObj) => {
                let days = getDaysInMonth(
                  fyObj.F_YEAR,
                  monthObj.A_MONTH.toUpperCase()
                );
                newChartData.push({
                  time: `${monthObj.A_MONTH}\n${fyObj.F_YEAR}`,

                  SPEED: monthObj.data.SPEED,
                });
              });
            }
          });
        }
      });

      setChartData(newChartData);
    }
  }, [visibleTable, bestSheetData]);

  return (
    <div>
      <div className="bg-dark text-white p-1">
        <h5>
          Speed graph =
          {visibleTable &&
            Object.entries(visibleTable).map(([key, value], index) => {
              return (
                <React.Fragment>{value ? `${key}, ` : null}</React.Fragment>
              );
            })}
        </h5>
      </div>
      <LineRaceChart data={chartData} title={"Speed graph"} />
      {/* <DottedBarChart data={chartData} /> */}
    </div>
  );
};
export default Speed;
